import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import AssignTypeModal from "../../modals/AssignTypeModal";
import SystemMessageModal from "../../modals/SystemMessageModal";
import SystemRejectModal from "../../modals/SystemRejectModal";
import { CARS, UPLOADS_URL } from "../../config/constants/api";
import swal from "sweetalert";
import { Put } from "../../config/api/put";
import { useSelector } from "react-redux";

const ExistingCarApproval = () => {
  const navigate = useNavigate();
  const [rejectionReason, setRejectionReason] = useState("");
  const [systemMessageModal1, setSystemMessageModal1] = useState(false);
  const [systemMessageModal2, setSystemMessageModal2] = useState(false);
  const [systemRejectModal, setSystemRejectModal] = useState(false);
  const [assignTypeModal, setAssignTypeModal] = useState(false);
  const location = useLocation();
  // const showButtons = false || location?.state?.showButtons;
  const [newServiceType, setServiceType] = useState(null);
  const token = useSelector((state) => state.user.userToken);
  const request = location?.state?.request;
  useEffect(() => {
    if (!request) {
      navigate(-1);
    }
    // eslint-disable-next-line
  }, []);
  const handleSubmit = (status) => {
    let data = {};
    if (status === "REJECTED") {
      data = {
        status,
        rejectionReason,
      };
    } else if(status === "ACTIVE") {
      data = {
        status:"APPROVED",
        serviceType: newServiceType ?? newServiceType,
      };
    }
    Put(`${CARS.validateRequest}${request._id}`, token, data)
      .then((response) => {
        if (response.status) {
          swal("System Alert!", response?.message, "success");
          navigate("/carUpdateRequest");
        }
      })
      .catch((err) => {
        let message = err?.response?.data?.message;
        console.log(":::;", err);
        if (message) swal("Oops!", message, "error");
      });
  };
  let image = request?.image ? request?.image : request?.car?.image;
  let gallery = request?.gallery ? request?.gallery : request?.car?.gallery;
  let allImages = [image, ...gallery];
  return (
    <div>
      <Row justify="center">
        <Col md={23} xs={22}>
          <div
            className="bg-white rounded-lg sm:py-16 py-8 my-12"
            style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
          >
            <div className="flex justify-between items-center mx-4 lg:mx-8 mb-4">
              <div className="flex justify-center items-center">
                <IoIosArrowRoundBack
                  onClick={() => navigate(-1)}
                  className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
                />
                <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                  Car Update Details
                </h3>
              </div>
              <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold">
                Service Type: {request?.serviceType ? request?.serviceType : request?.car?.serviceType} Luxury
              </h5>
            </div>
            <Row justify="center">
              <Col xs={22} sm={18} md={18} lg={14} xxl={12}>
                <div className="bg-[#EBEBEB] rounded-lg  items-center justify-center sm:py-12 py-6 ">
                  <Row justify="center">
                    <Col xs={18}>
                      <div className="flex justify-center items-center my-4 w-full">
                        <div className="flex flex-col items-start w-full">
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Car Brand
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {request?.brand
                              ? request?.brand
                              : request?.car?.brand}
                          </p>
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Car Model
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {request?.model
                              ? request?.model
                              : request?.car?.model}
                          </p>
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Car Type
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {request?.serviceType
                              ? request?.serviceType
                              : request?.car?.serviceType}
                          </p>
                        </div>
                        <div className="flex flex-col items-start w-full">
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Car Name
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {request?.name ? request?.name : request?.car?.name}
                          </p>
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Car Number
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {request?.carNumber
                              ? request?.carNumber
                              : request?.car?.carNumber}
                          </p>
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Passenger Capacity
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {request?.passengerCapacity
                              ? request?.passengerCapacity
                              : request?.car?.passengerCapacity}
                          </p>
                        </div>
                      </div>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1 w-full">
                        Car Images
                      </h5>
                      {Array.isArray(allImages) && (
                        <Row justify="center">
                          {allImages.map((image, index) => {
                            return (
                              <Col key={index} lg={4} md={6} xs={8}>
                                <img
                                  // style={{
                                  //   height: "100px",
                                  //   width: "100px",
                                  //   objectFit: "cover",
                                  //   objectPosition: "center",
                                  // }}
                                  src={UPLOADS_URL + image}
                                  alt="car"
                                />
                              </Col>
                            );
                          })}
                          {/* <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col> */}
                        </Row>
                      )}
                    </Col>
                  </Row>

                  {request.status==='PENDING' && <div className="flex flex-col items-center justify-center mt-8">
                    <button
                      className="uppercase bg-button py-4 px-6 text-black rounded-lg font-bold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4 font-euclid"
                      onClick={() => setAssignTypeModal(true)}
                    >
                      APPROVED CAR & ASSIGN SERVICE
                    </button>
                    <button
                      className=" uppercase bg-[#D90811] py-4 px-6 text-black rounded-lg font-bold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4 mt-4 font-euclid"
                      onClick={() => setSystemRejectModal(true)}
                    >
                      REJECT THIS CAR
                    </button>
                  </div>}
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      {systemMessageModal2 && (
        <SystemMessageModal
          systemMessageModal={systemMessageModal2}
          setSystemMessageModal={setSystemMessageModal2}
          message={"Driver Account request has been rejected successfully"}
          path={-1}
        />
      )}
      {systemMessageModal1 && (
        <SystemMessageModal
          systemMessageModal={systemMessageModal1}
          setSystemMessageModal={setSystemMessageModal1}
          message={"Car changes request approved successfully"}
          path={-1}
        />
      )}
      {systemRejectModal && (
        <SystemRejectModal
          systemRejectModal={systemRejectModal}
          setSystemRejectModal={setSystemRejectModal}
          setSystemMessageModal={setSystemMessageModal2}
          banUser={handleSubmit}
          setRejectionReason={setRejectionReason}
          rejectionReason={rejectionReason}
        />
      )}
      {assignTypeModal && (
        <AssignTypeModal
          assignTypeModal={assignTypeModal}
          setAssignTypeModal={setAssignTypeModal}
          setSystemMessageModal={setSystemMessageModal1}
          setServiceType={setServiceType}
          handleSubmit={handleSubmit}
        />
      )}
    </div>
  );
};

export default ExistingCarApproval;
